import {
  Component, Input, Output, EventEmitter, HostBinding, ElementRef, OnChanges, SimpleChanges, OnDestroy, OnInit, ViewChild,
  ViewEncapsulation, NgZone, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import {RowHeightCache} from './row-height-cache';
import {ScrollerEventArgs} from './types';
import { Subject, Subscription } from 'rxjs';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';

@Component({
  selector: 'app-scroller, [scroller]',
  templateUrl: './scroller.component.html',
  styleUrls: ['./scroller.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollerComponent implements OnInit, OnDestroy {

  @Input()
  get items(): any[] { return this._items; }
  set items(val: any[]) {
    //console.log(val)
    //console.log('reset2')
    this.totalItemsLength = 0;
    this.addRowsCnt = 1;
    this.nextSetStartIndex = 0;

    this._items = val;
    this.viewRowsMain.next(val);
    if (this.virtualScroll) {
      this.resetPosition();
      this.chunkRows(true);
    }
  }
  private _items: any[];

  @Input() virtualScroll: boolean;
  @Input() rowHeight: number;
  @Input() itemsPerRow: number = 20;
  @Input() rowHeightProp: string;

  @HostBinding('style.height.px')
  @Input() scrollHeight: number;

  @HostBinding('style.width.px')
  @Input() scrollWidth: number;

  @Input() itemsRest: any[];
  totalItemsLength = 0;

  @Output() scrollChange: EventEmitter<ScrollerEventArgs> = new EventEmitter();

  @HostBinding('class.dt-scroller') cssClass = true;
  @HostBinding('class.dt-virtual-scroll')
  get isVirtualScroll(): boolean {
    return this.virtualScroll;
  }

  @ViewChild('content', {static: false}) content: ElementRef;

  private viewRowsMain = new Subject<any[]>();
  viewRowsMain$ = this.viewRowsMain.asObservable();
  get viewRows(): any[] {
   return (this.virtualScroll) ? this._viewRows : this.items;
  }
  set viewRows(val: any[]) {
    this._viewRows = val;
  }
  private _viewRows: any[];

  scrollYPos: number = 0;
  scrollXPos: number = 0;
  prevScrollYPos: number = 0;
  prevScrollXPos: number = 0;
  element: HTMLElement;
  scrollLength: number;
  start: number;
  end: number;
  private previousStart: number;
  private previousEnd: number;
  private rowHeightCache: RowHeightCache = new RowHeightCache();
  private scrollListener: any;

  private subscriptions: Subscription[] = [];

  constructor(private cd: ChangeDetectorRef, element: ElementRef, private ngZone: NgZone, private commonFilterService: CommonFilterService) {
    this.element = element.nativeElement;
  }

  ngOnInit() {
    
    this.ngZone.runOutsideAngular(() => {
      this.scrollListener = this.onScrolled.bind(this);
      this.element.addEventListener('scroll', this.scrollListener);
    });

    //if (this.items.length < this.itemsPerRow) {  //IMP -SUSHEEL
    //  for (let i = this.items.length; i < this.itemsPerRow; i++)
    //    this.scrollHeight -= this.rowHeight;
    //}
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('changed')
        this.refreshed = true;

        this.totalItemsLength = 0;
        this.addRowsCnt = 1;
        this.nextSetStartIndex = 0;
      }
    );
    this.subscriptions.push(_broadSubRefresh);
  }

  //ngOnChanges(changes: SimpleChanges) {
    ////Do Refresh
    //this.commonFilterService.componentMethodCalled$.subscribe(
    //  //() => {
    //  //  alert('(Component2) Method called!');
    //  //}

    //  res => {
    //    this.items = [];
    //    this.viewRows = [];
    //    this.viewRowsMain.next([]);
    //  }
    //);
    
  //}

  ngOnDestroy() {
    this.element.removeEventListener('scroll', this.scrollListener);
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  refreshed = false;
  onScrolled(event: MouseEvent) {

    if (!this.refreshed) {
      this.chuckRowsMain();
      const dom: Element = event.currentTarget as Element;
      this.scrollYPos = dom.scrollTop;
      this.scrollXPos = dom.scrollLeft;

      let direction = null;
      if (this.scrollYPos < this.prevScrollYPos) {
        direction = 'up';
      } else if (this.scrollYPos > this.prevScrollYPos) {
        direction = 'down';
      }

      if (this.prevScrollYPos !== this.scrollYPos || this.prevScrollXPos !== this.scrollXPos) {
        if (direction && this.virtualScroll) {
          this.chunkRows();
          let topPadding = this.rowHeight * this.start;
          if (this.rowHeightProp) {
            topPadding = this.rowHeightCache.getRowOffset(this.start - 1);
          }
          this.ngZone.runOutsideAngular(() => {
            requestAnimationFrame(() => {
              this.content.nativeElement.style.transform = `translateY(${topPadding}px)`;
            });
          });
        }

        this.scrollChange.emit({
          direction,
          scrollYPos: this.scrollYPos,
          scrollXPos: this.scrollXPos
        });
        this.prevScrollYPos = this.scrollYPos;
        this.prevScrollXPos = this.scrollXPos;
      }
    }
    else {
      this.refreshed = false;
      //this.items = [];
    }
  }

  setOffsetY(offsetY: number) {
    if (this.element) {
      this.element.scrollTop = offsetY;
    }
  }

  setPageOffsetY(page: number) {
    const rowIndex = this.itemsPerRow * (page - 1);
    let offset = 0;
    if (this.rowHeightProp) {
      offset = this.rowHeightCache.getRowOffset(rowIndex - 1);
    } else {
      offset = this.rowHeight * rowIndex;
    }
    this.setOffsetY(offset);
  }

  private calculateDimensions() {
    if (this.rowHeightProp) {
      this.rowHeightCache.initCache(this.items, this.rowHeightProp);
    }
    if (this.items && this.items.length) {
      const totalRecords = this.items.length;
      if (this.rowHeightProp) {
        this.scrollLength = this.rowHeightCache.calcScrollLength(totalRecords);
      } else {
        this.scrollLength = this.rowHeight * totalRecords;
      }
    }
    if (this.scrollHeight && this.rowHeight) {
      this.itemsPerRow = Math.round(this.scrollHeight / this.rowHeight);
    } else {
      this.scrollHeight = this.itemsPerRow * this.rowHeight;
      if (this.scrollHeight > 0) {
        this.scrollHeight -= this.rowHeight; // for lazy load
      }
    }
  }

  //rows: any[];
  addRowsCnt = 1;
  nextSetStartIndex = 0;
  chuckRowsMain() {
    //console.log(this.items)
    //console.log(this.itemsRest)
    //console.log(this.items.length)
    //console.log(this.itemsRest.length)
    //console.log(this.totalItemsLength)
    //if (this.items.length == 0 && this.itemsRest.length == 0) {
    //  this.totalItemsLength = 0;
    //  this.addRowsCnt = 1;
    //  this.nextSetStartIndex = 0;
    //  console.log('reset')
    //}
    if (this.totalItemsLength == 0 && this.itemsRest.length > 0) {
      //console.log('reset1')
      this.totalItemsLength = this.items.length + this.itemsRest.length;
    }
    //console.log(this.totalItemsLength)
    if (this.items.length < this.totalItemsLength) {
      let sliced = [];
      let nextTwentySet = (this.addRowsCnt * 20) + 1;
      //console.log(this.nextSetStartIndex)
      //console.log(nextTwentySet)
      if (nextTwentySet < this.itemsRest.length) {
        //https://stackoverflow.com/questions/3580239/javascript-array-get-range-of-items
        if (this.itemsRest.length < (nextTwentySet + 20))
          sliced = this.itemsRest.slice(this.nextSetStartIndex, this.itemsRest.length);
        else
          sliced = this.itemsRest.slice(this.nextSetStartIndex, nextTwentySet);

        this.nextSetStartIndex = nextTwentySet;
        this.addRowsCnt++;
      }
      else {
        this.nextSetStartIndex = (this.addRowsCnt * 20) + 1;
        sliced = this.itemsRest;//.slice(this.nextSetStartIndex, this.itemsRest.length);
       //console.log(this.nextSetStartIndex)
        //console.log(this.itemsRest.length)
      }

      sliced.forEach((row, i) => {
        this.items.push(row);
      });
      //console.log(this.items)

      //console.log(this.items.length)
      this.viewRowsMain.next(this.items);
      //this.cd.detectChanges();
    }
  }

  chunkRows(force: boolean = false) {
    this.calculateDimensions();
    const totalRecords = this.items.length;
    if (this.rowHeightProp) {
      this.start = this.rowHeightCache.calcRowIndex(this.scrollYPos);
    } else {
      this.start = Math.floor(this.scrollYPos / this.rowHeight);
    }
    this.end = Math.min(totalRecords, this.start + this.itemsPerRow + 1);
    if ((this.end - this.start) < this.itemsPerRow) {
      this.start = totalRecords - this.itemsPerRow - 1;
      this.end = totalRecords;
    }

    if (this.start !== this.previousStart || this.end !== this.previousEnd || force === true) {
      const virtualRows = this.items.slice(this.start, this.end);
      this.previousStart = this.start;
      this.previousEnd = this.end;
      this.viewRows = virtualRows;
    }
  }

  resetPosition() {
    this.start = 0;
    this.end = 0;
    this.previousStart = 0;
    this.previousEnd = 0;
  }

}
